// extracted by mini-css-extract-plugin
export var btnBlock = "style-module--btn-block--36fc6";
export var container = "style-module--container--c3534";
export var desc = "style-module--desc--393b4";
export var icon = "style-module--icon--9aabf";
export var left = "style-module--left--ee580";
export var order = "style-module--order--7d3b6";
export var right = "style-module--right--ee3fb";
export var wait = "style-module--wait--3e350";